import React, { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'react-toastify';
import { fetchStockSuppliers, createStockSupplier } from '../../redux/api';
import { su } from './stockUi';

const SupplierSelect = ({
  valueId = '',
  valueName = '',
  onChange,
  className = '',
}) => {
  const [suppliers, setSuppliers] = useState([]);

  const loadSuppliers = async () => {
    try {
      const response = await fetchStockSuppliers();
      setSuppliers(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      setSuppliers([]);
    }
  };

  useEffect(() => {
    loadSuppliers();
  }, []);

  const handleSelect = (e) => {
    const id = e.target.value;
    if (id === '__current__') return;
    const selected = suppliers.find((item) => String(item.id || item._id) === String(id));
    onChange?.({
      id: id || '',
      name: selected?.name || '',
    });
  };

  const handleAdd = async () => {
    const name = window.prompt('Naziv dobavljača:', '');
    const trimmed = (name || '').trim();
    if (!trimmed) return;

    const existing = suppliers.find((item) => (item.name || '').toLowerCase() === trimmed.toLowerCase());
    if (existing) {
      onChange?.({ id: existing.id || existing._id, name: existing.name });
      return;
    }

    try {
      const created = await createStockSupplier({ name: trimmed });
      const doc = created?.data || {};
      await loadSuppliers();
      onChange?.({ id: doc.id || doc._id || '', name: doc.name || trimmed });
      toast.success('Dobavljač je dodat');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Greška pri dodavanju dobavljača');
    }
  };

  const matched = suppliers.find((item) =>
    (valueId && String(item.id || item._id) === String(valueId)) ||
    (valueName && item.name === valueName)
  );
  const selectedValue = matched ? (matched.id || matched._id) : (valueName ? '__current__' : '');

  return (
    <div className="flex gap-1.5">
      <select value={selectedValue} onChange={handleSelect} className={`${su.input} ${className}`}>
        <option value="">Izaberi dobavljača...</option>
        {!matched && valueName ? <option value="__current__">{valueName}</option> : null}
        {suppliers.map((supplier) => {
          const id = supplier.id || supplier._id;
          return (
            <option key={id} value={id}>
              {supplier.name}
            </option>
          );
        })}
      </select>
      <button
        type="button"
        onClick={handleAdd}
        className="h-8 px-2 bg-gray-900/70 border border-gray-600 rounded-md text-white hover:bg-gray-700 shrink-0"
        title="Dodaj novog dobavljača"
      >
        <Plus className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default SupplierSelect;
